import { type FunctionComponent } from "react";

import chiefArchitectIcon from "images/Common/chiefArchitect.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedChiefArchitect: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img
            alt=""
            src={chiefArchitectIcon}
            style={baseProps.style}
            className={baseProps.className}
        />
    );
};
